/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useCompanyStore, {
  countModule
} from '../../../store/companyStore/companyDetailsStore';
import useUserStore from '../../../store/userStore/userStore';

const getTotalUserCount = async (): Promise<any> => {
  const token = useUserStore.getState().userToken;
  const {company} = useUserStore.getState().userDetails;
  const params = {};
  const url = `${API_BASE_URL}${API_ENDPOINT_JSON.getTotalUserCount}/${company}`;

  try {
    const res: any = await axios.request({
      method: CRUDMethods.GET,
      url,
      headers: {
        Authorization: `Bearer ${token}`
      },
      params
    });

    useCompanyStore
      .getState()
      .setCurrentCount(
        countModule.externalStakeholders,
        res.data.data?.ExternalUserCount
      );

    useCompanyStore
      .getState()
      .setCurrentCount(
        countModule.internalUsers,
        res.data.data?.InternalUserCount
      );

    return res.data.data;
  } catch (err) {
    return [];
  }
};

export default getTotalUserCount;
